import * as angular from 'angular';

export const OrgSettingsComponent: angular.IComponentOptions = {
  template: `
    <div ui-view />
  `,
};
